import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import { Link } from 'react-router-dom';

const CreateDuplicateCampaign = () => {
  const dispatch = useDispatch();

  const actionType = 'DUPLICATE_CAMPAIGN';
  const { actionCreatedDuplicateCampaign, actionCreatedDuplicateCampaignLoading } = useSelector(
    (state) => state.general
  );
  const [actionData, setActionData] = useState({});

  if (actionCreatedDuplicateCampaign?._id) {
    dispatch(generalSet({ reduxField: 'actionCreatedDuplicateCampaign', value: {} }));
    window.location.href = '/actions';
  }

  return (
    <>
      <div>
        <Link to='/CreateAction' className='btn btn-outline-dark'>
          Change Action Type
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>
            Create Action: <span className='text-primary'>Duplicate Campaign</span>
          </h1>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6'>
            <input
              type='text'
              className='form-control'
              placeholder='Action name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setActionData({ ...actionData, name: e.target.value })}
            />
          </div>
        </div>
        {actionData.name ? (
          <>
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <button
                className='btn btn-outline-primary'
                disabled={actionCreatedDuplicateCampaignLoading}
                onClick={() => {
                  dispatch(generalSet({ reduxField: 'actionCreatedDuplicateCampaignLoading', value: true }));
                  dispatch(
                    apiAction({
                      route: 'actions/createAction',
                      reduxField: 'actionCreatedDuplicateCampaign',
                      actionType,
                      actionData,
                      setLoading: 'actionCreatedDuplicateCampaignLoading',
                    })
                  );
                }}
              >
                Create Action
              </button>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default CreateDuplicateCampaign;
